/**
 * Validate the inputs comply with the assigned rules.
 *
 * @param {object} data - data object to be validated.
 * @param {object} inputMap - an object mapping the inputs to their respective rules.
 * @property {string} inputMap.[PropertyName] - the data property name
 * @returns {object} - Array with the validation result.
 * An object that indicates wether the input is valid and a string with the error message.
 */

export default function validate(data, inputMap) {
  const properties = Object.keys(inputMap);

  const validationResult = properties.reduce((result, propertyName) => {
    const rules = inputMap[propertyName] || [];
    const rulesResults = {};
    rules.forEach((ruleFunc) => {
      const [isValid, errorMessage] = ruleFunc(data[propertyName]);
      if (!isValid) {
        rulesResults[propertyName] = errorMessage;
      }
    });

    return { ...result, ...rulesResults };
  }, {});

  return validationResult;
}
